<template>
  <div class="wrapper">
      <div id="logo-wrap">
          <transition name="spin" mode="out-in">
            <img 
              :src="logos[currentLogo]" 
              :key="currentLogo" 
              id="logo"
            />
          </transition>
          <h4>Appointment</h4>
      </div>
      <div id="choose" v-show="!success_show">
        <p-button type="info" round @click.native.prevent="chooseNew" class="choices">
              New Client
        </p-button>
        <p-button type="info" round @click.native.prevent="chooseExist" class="choices">
              Existing Client
        </p-button>
      </div>
      <div id="appointment-form" v-show="choose_show">
        <loader v-show="loader"/>
        <transition name="fade">
        <form @submit.prevent v-show="!success_show">
          <div class="row">
            <loader v-if="loader_save"/>   
            <div class="col-md-12" v-show="choose_info">
              <fg-input
                        v-model="info.first_name"
                        label="First Name"
                        placeholder="First Name"
                        :readonly="isReadOnly"
                      />
              <fg-input
                        v-model="info.last_name"
                        placeholder="Last Name"
                        label="Last Name"
                        :readonly="isReadOnly"
                />  
                
              <fg-input
                        v-model="info.contact_number"
                        placeholder="Contact Number"
                        label="Contact Number"
                        :readonly="isReadOnly"
                /> 

                <div class="form-group">
                  <label class="control-label">Select Branch</label><br/>
                  <select v-model="info.branch_id" class="branch-list">
                    <option disabled value="">Please select a branch</option>
                    <option value="1">Gaerlan</option>
                    <option value="2">Dolores (New)</option>
                  </select>
                  <a href="#" class="view-branch" @click.prevent="viewBranch">View Branch</a>
                </div>
            </div>
            <div class="col-md-12" v-show="choose_existing">
          
                
              <fg-input
                        v-model="info.registered_number"
                        placeholder="Enter Contact Number"
                        label="Enter your registered mobile number"
                /> 

                <p-button type="info" round @click.native.prevent="chooseSearch" class="choices">
                    Search
                </p-button>
            </div>
          </div>
          

          <div v-show="choose_found">
            <div class="gluata-services">
                <label>if Gluta Services?</label>
                <input type="checkbox" v-if = "gluta_services == 1" checked value="true" v-model="gluta_services"  @change="getTimeList" /><input type="checkbox" v-else value="true"  @change="getTimeList" v-model="gluta_services"/> Yes
                
                </div>
              <loader v-if="loader_date"/>  
              <label>Please Enter Date</label><br/>  
            <input type="date" v-model="info.date" v-on:change="changeDate" placeholder="Enter Date"/>
            <select v-model="info.time" class="time-list">
              <option value="">Select Time</option>
              <option v-for="(item, index) in time_list"  :value="item">
                {{item}}
              </option>
            </select>

            

            <div class="w-full mt-4 p-10">
                <h4>Please fillup services</h4>
                <div v-for="(service, index) in services" :key="index">
                  <div class="flex justify-start ml-2 mt-4">
                    <input
                      v-model="service.services_name"
                      placeholder="Service"
                      class="w-full py-2 border border-indigo-500 rounded"
                    />
                    <p-button type="info" round @click.native.prevent="remove(index)" class="trash-service"><span class="ti-trash"></span></p-button>
                  </div>
                </div>
              </div>
              <p-button type="info" round @click.native.prevent="addMore()" class="add-services">Add more services</p-button>
              <div class="form-group mt-4 consent-wrap">
                <label>
                  <input type="checkbox" v-model="info.data_consent" />
                  I agree to the <a href="#" @click.prevent="showConsent">Data Privacy Consent</a>
                </label>
              </div>
              <div style="clear:both; height: 30px;"></div>
                <div class="text-center">
                  <p-button type="info" round @click.native.prevent="addAppointment" id="submit-appt">
                    Submit
                  </p-button>
                </div>
                <div class="clearfix"></div>
          </div>
          
        </form>
      </transition>
      <transition name="fade">
        <div id="success" v-show="success_show">
          <h3>Thank you for scheduling your appointment with us! 🥳</h3>
          <h4>Your submission has been received. 🥂</h4>
          <h4>Our team will review your request and confirm the details shortly. 🗒️</h4>
        </div>
      </transition>
     
      </div>
      <Modal 
              :showModal="modalVisible" 
              :title="modal_title" 
              @close="closeModalClient"
            >
              <div v-if="selectedBranch">
                <img :src="selectedBranch.map" alt="Branch Map" style="width:100%; margin-bottom: 15px;" />
                <p><strong>Address:</strong> {{ selectedBranch.address }}</p>
              </div>
            </Modal>
            <Modal 
        :showModal="consentVisible" 
        title="Data Privacy Consent" 
        @close="closeConsent"
      >
        <div class="consent-content">
          <p>
            By booking an appointment, you voluntarily provide personal data such as 
            your name, contact number, and appointment details. This information will 
            be used solely for scheduling, confirming, and providing services.
          </p>
          <p>
            Your data will not be shared with unauthorized third parties. By agreeing, 
            you consent to the collection and processing of your information in 
            accordance with the Data Privacy Act of 2012 (RA 10173).
          </p>
          <p>
            If you wish to withdraw consent or have your data deleted, please contact 
            us directly.
          </p>
          <p>Email: <a href="mailto:admin@kagay-an.ph">beauty@kagay-an.ph</a></p>
        </div>
      </Modal>

    </div>
</template>
<style scoped>
#appointment-form{width:30%; margin:0 auto;  padding: 30px; border-radius: 10px 10px 10px 10px;
-webkit-border-radius: 10px 10px 10px 10px;
-moz-border-radius: 10px 10px 10px 10px;}

#choose{margin:0 auto;  padding: 30px; border-radius: 10px 10px 10px 10px;
-webkit-border-radius: 10px 10px 10px 10px;
-moz-border-radius: 10px 10px 10px 10px; text-align: center; }
#choose button{width: 24%;  margin: 0 auto 16px auto;}
.choices{display: block; margin-bottom: 20px;}
#logo-wrap{width:20%; margin:0 auto; margin-bottom: 10px; text-align:center;}
#logo{width:50%; margin-top:50px; margin-bottom: 20px;}
#logo input[type="text"], #logo input[type="password"]{ border: 1px solid;}
#logo label{font-weight: bold!important;}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

#success{text-align: center; background: #008080; color: #fff; padding: 26px; border-radius: 22px; }
#success h3{font-size: 20px;  font-weight: bold;}
#success h4{font-size: 20px;  font-weight: bold;}
.mx-datepicker-range {width: 230px;}

/* transition spin effect */
.spin-enter-active {
  animation: spinIn 0.6s;
}
.spin-leave-active {
  animation: spinOut 0.6s;
}

@keyframes spinIn {
  from { transform: rotateY(180deg); opacity: 0; }
  to { transform: rotateY(0); opacity: 1; }
}
@keyframes spinOut {
  from { transform: rotateY(0); opacity: 1; }
  to { transform: rotateY(-180deg); opacity: 0; }
}

#submit-appt{padding: 10px 34px; font-size: 13px; margin: 40px;}
.view-branch{margin-left: 5px; font-weight: bold;}
.consent-content {
  font-size: 14px;
  line-height: 1.6;
}

.consent-wrap{margin-top: 60px!important;}

</style>
<script>
import api  from "@/static/config.json";
import axios from 'axios'
import Loader from "@/components/Loader";
import Modal from '@/components/Modal';
export default {

  components: {
    Loader,
    Modal
  },
  data(){
    return{
      logos: [
        require('@/assets/img/logo.png'),
        require('@/assets/img/logo2.png')
      ],
      currentLogo: 0,
      interval: null,
      email: '',
      password: '',
      type: ["", "info", "success", "warning", "danger"],
      consentVisible: false,
      notifications: {
        topCenter: false,
      },
      loader:false,
      info:{
          id:'',
          first_name:'',
          last_name:'',
          contact_number:'',
          services:'',
          date:'',
          time:'',
          status:'',
          client_type:'',
          registered_number:'',
          data_consent: false
      },
      time_list:[],
      gluta_services:'',
      services: [
        {
          services_name: "",
        },
      ],
      loader_save: false,
      success_show : false,
      loader_date:false,
      choose_existing:false,
      choose_new:false,
      choose_show:false,
      choose_found:false,
      choose_info:false,
      isReadOnly: false,
      modalVisible: false,
      modal_title: '',
      selectedBranch: null,
      branches: {
        1: {
          name: 'Gaerlan St.',
          map: 'https://beauty.kagay-an.ph/wp-content/uploads/2025/02/kbl_map-1.png',
          address: 'Main Branch : Pabayo - Gaerlan St.'
        },
        2: {
          name: 'Dolores St.',
          map: 'https://beauty.kagay-an.ph/wp-content/uploads/2025/02/new_map.png',
          address: 'New Branch : Velez - Fernandez / Dolores St.'
        }
      }
    }
  },
  methods: {
    addAppointment(){
      const service = this.services;
      const self_cr = this;
      let count_services = 0;
      Object.keys(service).forEach(function(key) {

         if(service[key].services_name==""){
              count_services++;
         }

      });

      let error_count = 0;

      if(this.info.first_name==""){
          error_count++
          this.notifyVue('top', 'center','danger','Please enter First Name','ti-hand-stop')
      }
      
      if(this.info.last_name==""){
        error_count++
        this.notifyVue('top', 'center','danger','Please enter Last Name','ti-hand-stop')
      }
      
      if(this.info.contact_number==""){
        error_count++
        this.notifyVue('top', 'center','danger','Please enter Contact Number','ti-hand-stop')
      } else if (!this.isValidPhilippineNumber(this.info.contact_number)) {
        error_count++
        this.notifyVue('top', 'center','danger','Invalid Philippine mobile number','ti-hand-stop')
      }
      
      if(this.info.time==""){
        error_count++
        this.notifyVue('top', 'center','danger','Please enter Time','ti-hand-stop')
      }
      
      if(this.info.date==""){
        error_count++
        this.notifyVue('top', 'center','danger','Please enter Date','ti-hand-stop')
      }
      
      if(count_services>0){
        error_count++
        this.notifyVue('top', 'center','danger','Please enter Services','ti-hand-stop')
      }

      if (!this.info.data_consent) {
        error_count++
        this.notifyVue('top', 'center', 'danger', 'Please agree to the Data Privacy Consent', 'ti-hand-stop')
      }

      if(error_count==0){
      const token = localStorage.getItem('token');
      this.loader_save = true;
      let self = this;
            axios.post(api.API_URL+'/appointment-guest/store', {
                    first_name: self.info.first_name,
                    last_name: self.info.last_name,
                    contact_number: self.info.contact_number,
                    time: self.info.time,
                    date: self.info.date,
                    services:self.services,
                    gluta_services:self.gluta_services,
                    branch_id:self.info.branch_id,
                    client_type: 'new'
                },
                
                {
                 headers: { Authorization: `Bearer ${token}`}
                }
                )
                    .then((data) => {
                      self.loader_save = false;
                      self.notifyVue('top', 'center','success','Appointment Successfully Added','ti-announcement')
                      self.success_show = true;
                      self.info.first_name = ''
                      self.info.last_name = ''
                      self.info.contact_number = ''
                      self.info.status = ''
                      self.info.date = ''
                      self.info.time = ''
                      self.services = []
                      
                     
                      
                    })
                    .catch((error) => {
                      try {
                           self.loader_save = false;
                          if(error.response.status==400){
                            self.notifyVue('top', 'center','danger',error.response.data.error.message,'ti-hand-stop')
                          }else if(error.response.status==422){
                            for (const [key, value] of Object.entries(error.response.data)) {
                              self.notifyVue('top', 'center','danger',value,'ti-hand-stop')
                            }
                            
                           
                          }
                        }
                        catch(err) {
                        
                        }
                    });

      }
      
      
    },
      notifyVue(verticalAlign, horizontalAlign,type,msg,icon) {
      const color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        title:msg,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },
    getTimeList () {
                let self = this;
                let date = this.info.date;
                let gluta_services = this.gluta_services;
                this.loader_date = true;

                axios.get(api.API_URL+`/generate-time?date=${date}&gluta_services=${gluta_services}`,
                  {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                  }
                ).then(({data})=>{
                  this.loader_date = false;
                  self.time_list = data

                }).catch(({ response })=>{
                      if(response.data.error.code =='token_could_not_verified'){
                          this.$router.push('/login')
                      }
                })
    },
    addMore() {
      this.services.push({
        services_name: ""
      });
    },
    remove(index) {
      this.services.splice(index, 1);
      this.price(); 
    },
    changeDate(){
      this.getTimeList();
    },
    chooseNew(){
      this.isReadOnly = false;
      this.choose_show = true;
      this.choose_new = true;
      this.choose_existing = false;
      this.choose_found = true;
      this.choose_info = true;
      this.info.first_name = '';
      this.info.last_name = '';
      this.info.contact_number = '';
      this.info.registered_number = '';
    },
    chooseExist(){
      this.info.registered_number = '';
      this.choose_show = true;
      this.choose_existing = true;
      this.choose_new = false;
      this.choose_found = false;
      this.choose_info = false;
    },
    chooseSearch(){

        this.loader = false;
        let self = this;
        let search_val = this.info.registered_number;
        let count_error = 0;

        if(search_val==""){
          self.notifyVue('top', 'center','danger','Please enter your registered mobile number','ti-hand-stop')
          count_error++;
        }else if (isNaN(search_val)) {
          self.notifyVue('top', 'center','danger','Please enter a number','ti-hand-stop')
          count_error++;
        }

        if(count_error==0){
          self.loader = true;
            axios.get(api.API_URL+`/client-number?search=${search_val}`,
                  {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                  }
                ).then(({data})=>{
                  self.loader = false;
                  if(data.success==false){
                    self.choose_found = false;
                     self.notifyVue('top', 'center','danger','Client not found.','ti-hand-stop')
                  }else{
                    self.notifyVue('top', 'center','success','Client found.','ti-hand-stop')
                    self.choose_found = true;
                    self.info.first_name = data.first_name;
                    self.info.last_name = data.last_name;
                    self.info.contact_number = data.contact_number;
                    self.isReadOnly = true;
                    self.choose_info = true;
                    self.choose_existing = false;
                  }

                }).catch(({ response })=>{
                      if(response.data.error.code =='token_could_not_verified'){
                          this.$router.push('/login')
                      }
                })
        }
         
    },
    viewBranch() {
      if (!this.info.branch_id) {
        this.notifyVue('top', 'center', 'danger', 'Please select a branch first', 'ti-hand-stop')
        return
      }
      const branch = this.branches[this.info.branch_id]
      this.selectedBranch = branch
      this.modal_title = branch.name
      this.modalVisible = true
    },
    closeModalClient() {
      this.modalVisible = false
    },
    showConsent() {
      this.consentVisible = true
    },
    closeConsent() {
      this.consentVisible = false
    },
    isValidPhilippineNumber(number) {
      // Remove spaces, dashes, or parentheses
      const cleaned = number.replace(/[^0-9]/g, '');

      // Check formats
      const regex = /^(09\d{9}|639\d{9})$/;

      return regex.test(cleaned);
    }
  },
  mounted(){
      this.interval = setInterval(() => {
        this.currentLogo = (this.currentLogo + 1) % this.logos.length
      }, 5000) // every 5 seconds
  },
  beforeDestroy() {
    clearInterval(this.interval)
  }
};
</script>
